import { useIntl } from 'react-intl';

import { IconCross } from '@xing-com/icons';

import * as Styled from './closing-indicator.styles';
import type { ClosingIndicatorProps } from './closing-indicator.types';

export const ClosingIndicator = ({
  className,
  href,
  onClick,
  size = 'medium',
  to,
  type,
  ...props
}: ClosingIndicatorProps): JSX.Element => {
  const intl = useIntl();
  const commonProps = {
    $size: size,
    'aria-label': intl.formatMessage({
      id: 'XDS_CLOSE_BUTTON_A11Y',
      defaultMessage: 'Close',
    }),
    'data-xds': 'ClosingIndicator',
    className,
    onClick,
    type: type ?? (!to && !href ? 'button' : undefined),
    ...props,
  };

  const buttonContent = <IconCross width={24} height={24} aria-hidden="true" />;

  if (to || href) {
    return (
      <Styled.ClosingIndicatorLink
        {...(to && { to })}
        {...(href && { href })}
        {...commonProps}
        {...props}
      >
        {buttonContent}
      </Styled.ClosingIndicatorLink>
    );
  }

  return (
    <Styled.ClosingIndicator {...commonProps} {...props}>
      {buttonContent}
    </Styled.ClosingIndicator>
  );
};

ClosingIndicator.displayName = 'ClosingIndicator';
